import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizAnalysisOverview;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { MetricGroup } from '@instructure/ui-metric';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import FormattedDuration from '../../../common/components/shared/FormattedDuration';
import t from '@instructure/quiz-i18n/format-message';
import Card from '../../../common/components/shared/Card';
import Spinner from '../../../common/components/shared/spinner/Spinner';
import CentileDistribution from '../charts/CentileDistribution';
import MetricsListItem from '../MetricsListItem';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizAnalysisOverview = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizAnalysisOverview = /*#__PURE__*/function (_Component) {
  function QuizAnalysisOverview() {
    var _this2;
    _classCallCheck(this, QuizAnalysisOverview);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizAnalysisOverview, [].concat(args));
    _defineProperty(_this2, "renderBatchTimestamp", function () {
      if (_this2.props.quizAnalysis.batchTimestamp) {
        var timestamp = Date.parse(_this2.props.quizAnalysis.batchTimestamp);
        return jsx(Text, {
          color: "secondary",
          size: "x-small"
        }, jsx("br", null), jsx("b", null, t('Data Last Updated:')), "\xA0", t.date(timestamp, 'medium'));
      }
    });
    return _this2;
  }
  _inherits(QuizAnalysisOverview, _Component);
  return _createClass(QuizAnalysisOverview, [{
    key: "defaultMetrics",
    value: function defaultMetrics() {
      var quizAnalysis = this.props.quizAnalysis;
      var formattedElapsedTime = jsx(FormattedDuration, {
        fontSize: "x-large",
        seconds: quizAnalysis.meanElapsedTime()
      });
      return jsx(MetricGroup, null, jsx(MetricsListItem, {
        key: "highScore",
        renderLabel: t('High Score'),
        renderValue: quizAnalysis.highScore(),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "lowScore",
        renderLabel: t('Low Score'),
        renderValue: quizAnalysis.lowScore(),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "meanScore",
        renderLabel: t('Mean Score'),
        renderValue: quizAnalysis.meanScore(),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "standardDeviation",
        renderLabel: t('Standard Deviation'),
        renderValue: quizAnalysis.standardDeviation(),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "meanElapsedTime",
        renderLabel: t('Mean Elapsed Time'),
        renderValue: jsx(Text, {
          size: "x-large"
        }, formattedElapsedTime),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }), jsx(MetricsListItem, {
        key: "cronbachsAlpha",
        renderLabel: t("Cronbach's Alpha"),
        renderValue: quizAnalysis.cronbachsAlpha(),
        customStyles: this.props.styles.metric,
        isGroupChild: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        animateDelay = _this$props.animateDelay,
        animateDuration = _this$props.animateDuration,
        quizAnalysis = _this$props.quizAnalysis,
        quizTitle = _this$props.quizTitle;
      if (!quizAnalysis.isLoaded()) return jsx(Spinner, null);
      var list = React.Children.count(this.props.children) === 0 ? this.defaultMetrics() : jsx(MetricGroup, null, this.props.children);
      return jsx(Card, {
        css: this.props.styles.root
      }, jsx(Heading, {
        level: "h4",
        as: "h2",
        color: "primary"
      }, quizTitle), jsx("div", {
        css: this.props.styles.metricWrapper
      }, list), jsx("div", {
        css: this.props.styles.wrapper
      }, jsx(CentileDistribution, {
        animateDelay: animateDelay,
        animateDuration: animateDuration,
        summaryDistribution: quizAnalysis.decileDistribution(),
        visualDistribution: quizAnalysis.centileDistribution()
      })), this.renderBatchTimestamp());
    }
  }]);
}(Component), _defineProperty(_QuizAnalysisOverview, "displayName", 'QuizAnalysisOverview'), _defineProperty(_QuizAnalysisOverview, "componentId", "Quizzes".concat(_QuizAnalysisOverview.displayName)), _defineProperty(_QuizAnalysisOverview, "propTypes", {
  animateDelay: PropTypes.number,
  animateDuration: PropTypes.number,
  quizAnalysis: ImmutablePropTypes.record.isRequired,
  quizTitle: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
  styles: PropTypes.object
}), _defineProperty(_QuizAnalysisOverview, "defaultProps", {
  animateDelay: void 0,
  animateDuration: void 0,
  quizTitle: '',
  children: []
}), _QuizAnalysisOverview)) || _class);
export default QuizAnalysisOverview;